import React, { PropsWithChildren } from 'react';
import {
    ContextMenuWriteContext,
    ContextMenuReadContext,
    ContextMenuReadContextValue,
} from './context-menu-state-context';

export function ContextMenuStateProvider(
    props: PropsWithChildren<Record<never, never>>
): JSX.Element {
    const [currentValue, setCurrentValue] = React.useState<ContextMenuReadContextValue | undefined>(
        undefined
    );
    // We are using a boolean to ignore anything but the current value within a given time period.
    // This is important because we have nested context menu handlers that can triggered different
    // context menus, e.g. a unit pull within an event row.
    // We cannot use `debounce` because we are looking for the first value. Neither can we use `throttle`
    // as it does not drop values, but just spread them out.
    // Without this logic, we would always open the event context menu, as the last write wins.
    // Another approach would be to monkey-patch the event and use that instead,
    // but that would require tampering with React's event types.
    const ignoreValue = React.useRef(false);
    const setContextValue = React.useCallback(
        (contextValue: ContextMenuReadContextValue) => {
            if (ignoreValue.current) {
                return;
            }
            setCurrentValue(contextValue);
            ignoreValue.current = true;
            setTimeout(() => (ignoreValue.current = false), 10);
        },

        [setCurrentValue]
    );
    return (
        <ContextMenuWriteContext.Provider value={setContextValue}>
            <ContextMenuReadContext.Provider value={currentValue}>
                {props.children}
            </ContextMenuReadContext.Provider>
        </ContextMenuWriteContext.Provider>
    );
}
